import { LinkField, MenuLinkField } from '@/payload-types'
import { ComponentProps } from 'react'
import { Link } from '@/i18n/navigation'

export const getLinkUrl = (link: MenuLinkField): ComponentProps<typeof Link>['href'] | null => {
  if (
    link?.type === 'reference' &&
    link.reference?.value &&
    typeof link.reference.value !== 'number'
  ) {
    if (link.reference.relationTo == 'pages') {
      const slug = link.reference.value.slug as string
      return { pathname: '/[slug]', params: { slug } }
    }
  }

  return null
}

export const getCtaUrl = (
  link: LinkField | undefined,
): ComponentProps<typeof Link>['href'] | null => {
  if (!link || !link.enabled) return null

  if (
    link?.type === 'internal' &&
    link.reference?.value &&
    typeof link.reference.value !== 'number'
  ) {
    if (link.reference.relationTo == 'pages') {
      const slug = link.reference.value.slug as string

      // if (link.reference.value.parent && typeof link.reference.value.parent === 'object') {
      //   return {
      //     pathname: '/[...slug]',
      //     params: { slug: [link.reference.value.parent.slug as string, slug] },
      //   }
      // }

      return { pathname: '/[slug]', params: { slug } }
    }

    if (link.reference.relationTo == 'globalOffers') {
      const slug = link.reference.value.slug as string

      return { pathname: '/offers/[slug]', params: { slug } }
    }

    if (link.reference.relationTo == 'hotels') {
      if (typeof link.reference.value.city === 'number') return null

      const country = link.reference.value.city.countrySlug
      const city = link.reference.value.city.slug
      const hotel = link.reference.value.slug

      return {
        pathname: '/hotels/[country]/[city]/[hotel]',
        params: { country: country as string, city: city as string, hotel: hotel as string },
      }
    }

    if (link.reference.relationTo == 'cities') {
      const country = link.reference.value.countrySlug
      const city = link.reference.value.slug
      return {
        pathname: '/hotels/[country]/[city]',
        params: { country: country as string, city: city as string },
      }
    }

    if (link.reference.relationTo == 'countries') {
      const country = link.reference.value.slug
      return {
        pathname: '/hotels/[country]',
        params: { country: country as string },
      }
    }
  }

  return null
}
